import React from 'react';
import styled from 'styled-components';

import facebookIcon from '../assets/icons/facebook.svg';
import twitterIcon from '../assets/icons/twitter.svg';
import youtubeIcon from '../assets/icons/youtube.svg';


const FooterContainer = styled.footer`
  @media (min-width: 992px) {
    position: fixed;
  }
`;

const FooterSection = styled.div`
  float: left;
  padding: 0 1.37vw;
  border-right: 1px solid;

  @media (min-width: 992px) {
    &.first{
      padding-left: 0;
    }
  }

  &.last {
    border-right: none;
    border-left: 1px solid;
  }

  &.address {
    margin-top: -9px;
    
    &.last-address{
      border-right: none;
    }
  }

  @media (max-width: 991px) {
    &.social-icons{
      flex: 1;
    }

    &.mobile-last{
      border-right: none;
      border-left: none;
    }

    &.v-center{
      display: flex;
      align-items: center;
    }
  }
`;

const SocialIconsContainer = styled.div`
  display: initial;
  border-bottom: 1px solid;
  padding-bottom: 24px;

  @media (max-width: 991px) {
    display: flex;
    text-align: center;
    margin-bottom: 20px;

    &.last{
      border-bottom: none;
      margin-bottom: -52px;
    }
  }
`;

const SocialIcon = styled.img`
  width: 1.07vw;

  @media (max-width: 64em) {
    width: 4.07vw
  }
`;

const FooterLink = styled.a`
  text-decoration: none;
  color: inherit;
  cursor: pointer;
  font-size: 0.94vw;

  @media (max-width: 64em) {
    font-size: 2.94vw;
    width: 100%;
  }
`;

const Footer = ({ privacyPolicyToggle }) => (
  <FooterContainer>
    <SocialIconsContainer>
      <FooterSection className="first social-icons">
        <FooterLink
          href="https://www.facebook.com/LeafyCode"
          target="_blank"
          rel="noopener noreferrer"
        >
          <SocialIcon src={facebookIcon} alt="Facebook" />
        </FooterLink>
      </FooterSection>
      <FooterSection className="social-icons">
        <FooterLink
          href="https://twitter.com/LeafyCode"
          target="_blank"
          rel="noopener noreferrer"
        >
          <SocialIcon src={twitterIcon} alt="Twitter" />
        </FooterLink>
      </FooterSection>
      <FooterSection className="social-icons mobile-last">
        <FooterLink
          href="https://www.youtube.com/channel/UCMb-c2UdxjqkQu82aNo1fhw"
          target="_blank"
          rel="noopener noreferrer"
        >
          <SocialIcon src={youtubeIcon} alt="YouTube" />
        </FooterLink>
      </FooterSection>
    </SocialIconsContainer>

    <SocialIconsContainer>
      <FooterSection className="social-icons v-center">
        <FooterLink href="tel:+94114663302">+94 114 66 33 02</FooterLink>,&nbsp;
        <FooterLink href="tel:+94 766707355">+94 766 707 355</FooterLink>

      </FooterSection>
      <FooterSection className="social-icons mobile-last v-center">
        <FooterLink href="mailto:hello@leafycode.com">hello@leafycode.com</FooterLink>
      </FooterSection>
    </SocialIconsContainer>

    <SocialIconsContainer>
      <FooterSection className="address last-address social-icons mobile-last">
        <FooterLink
          href="https://www.google.lk/maps/dir/''/Leafy+Code,+6.867727,+79.966069,+Sri+Lanka/@6.86
         77219,79.8960284,12z/data=!3m1!4b1!4m8!4m7!1m0!1m5!1m1!1s0x3ae25102c2c6c617:0x52d6517a
         3f03ccad!2m2!1d79.966069!2d6.867727"
          target="_blank"
          rel="noopener noreferrer"
        >
         28/3/C,<br />
         Ambuldeniya MW, Hokandara, Sri Lanka
      </FooterLink>
      </FooterSection>
    </SocialIconsContainer>
    <SocialIconsContainer className="last">
      <FooterSection className="last social-icons mobile-last">
        <FooterLink onClick={privacyPolicyToggle}>Privacy Policy</FooterLink>
      </FooterSection>
    </SocialIconsContainer>
  </FooterContainer>
);

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer.js